<template>
    <nav id="mobile-nav">
        <ul id="nav-list">
            <li>
                <router-link
                    :to="{ path: '/' }"
                    class="mm-listitem__text r-link"
                    >Home</router-link
                >
            </li>
            <li v-if="useProducts">
                <span>Products</span>

                <ul>

                    <li v-for="(category, index) in categories"
                                :key="'scID' + index">
                        <strong class="category-heading">{{ category.select_code.title }}</strong>
                        <ul>
                            <li v-for="(subCategory, index) in category.commodity_code"
                                        :key="'ccID' + index">
                                        <router-link
                                            :to="{
                                                name: 'products',
                                                query: {
                                                    scID: category.select_code.id,
                                                    ccID: subCategory.id
                                                }
                                            }" class="mm-listitem__text r-link">{{ subCategory.title }}</router-link>
                            </li>

                        </ul>
                    </li>


                </ul>

            </li>
            <li>
                <router-link
                    :to="{ path: '/brands' }"
                    class="mm-listitem__text r-link"
                    >Brands</router-link
                >
            </li>
            <li>
                <span>Company</span>
                <ul>
                    <li>
                        <router-link
                            :to="{ name: 'knowus' }"
                            class="mm-listitem__text r-link">
                            Know Us
                        </router-link>
                    </li>
                    <li>
                        <a href="https://www.pipglobal.com/" 
                        target="_blank"
                        class="mm-listitem__text r-link">
                            PIP Global
                        </a>
                    </li>
                    <li>
                        <router-link
                            :to="{ name: 'locations' }"
                            class="mm-listitem__text r-link">
                            Global Locations
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            :to="{ name: 'careeropportunities'}"
                            class="mm-listitem__text r-link">
                            Career Opportunities
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            :to="{ name: 'tradeshowcalendar'}"
                            class="mm-listitem__text r-link">
                            Tradeshow Calendar
                        </router-link>
                    </li>
                    <li>
                        <a href="" class="mm-listitem__text r-link">
                            Privacy Policy
                        </a>
                    </li>
                    <li>
                        <a href="" class="mm-listitem__text r-link">
                            Contact
                        </a>
                    </li>
                </ul>
            </li>
            <li>
                <router-link
                    :to="{ path: '/contact' }"
                    class="mm-listitem__text r-link"
                    >Contact Us</router-link
                >
            </li>
            <li>
                <a
                    href="https://www.amazon.com/stores/WestChester/page/543ACA2A-20AE-4A4A-800E-BB61C4257567?ref_=ast_bln"
                    class="mm-listitem__text r-link"
                    target="_blank"
                    aria-label='Link opens in new window (amazon.com/stores/WestChester)'
                    >BUY NOW</a>
            </li>

            <li v-if="isLoggedIn">
                <router-link
                    :to="{ name: 'myAccount' }"
                    class="mm-listitem__text r-link"
                    >My Account</router-link
                >
            </li>
            <li v-if="isLoggedIn">
                <router-link
                    :to="{ name: 'changePassword' }"
                    class="mm-listitem__text r-link"
                    >Change Password</router-link
                >
            </li>
            <li v-if="isLoggedIn && user.user_group_id == 8">
                <router-link
                    :to="{ name: 'userList' }"
                    class="mm-listitem__text r-link"
                    >Users List</router-link
                >
            </li>
            <li v-if="isLoggedIn && user.approved == 'y'">
                <router-link
                    :to="{ name: 'myTools' }"
                    class="mm-listitem__text r-link"
                    >My Tools</router-link
                >
            </li>
            <li v-if="isLoggedIn && user.approved == 'y'">
                <router-link
                    :to="{ name: 'SpecSheetDownload' }"
                    class="mm-listitem__text r-link"
                    >Spec Sheet Portal</router-link
                >
            </li>

            <li v-if="isLoggedIn">
                <a
                    href="javascript:void(0);"
                    @click.prevent="logout"
                    class="mm-listitem__text r-link"
                    >Log Out</a
                >
            </li>

            <li v-else>
                <router-link
                    :to="{ path: '/auth/login' }"
                    class="mm-listitem__text r-link"
                    >Distributor Login</router-link
                >
            </li>
            <li>
                <router-link
                    :to="{ name: 'privacy' }"
                    class="mm-listitem__text r-link"
                    >Privacy Policy</router-link
                >
            </li>
        </ul>
    </nav>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { logIn, logOut } from "../utils/auth";
export default {
    data() {
        return {};
    },
    computed: {
        ...mapState([
            "isLoggedIn",
            "userEmail",
            "user",
            "useAdmin",
            "useLocale",
            "categories",
            "useProducts"
        ]),
    },
    methods: {
        closeMenu() {
            api.close();
        },

        async logout() {
            try {
                axios.post("/logout");
                this.$store.dispatch("logout");
                this.$router.push({ name: "home" });
            } catch (error) {
                this.$store.dispatch("logout");
            }
        }
    },
    created() {
        document.addEventListener("DOMContentLoaded", () => {
            const menu = new Mmenu("#mobile-nav", {
                extensions: ["theme-dark"],
                counters: false,
                navbars: [
                    {
                        position: "top",
                        content: ["prev", "title"]
                    },
                    {
                        position: "bottom",
                        content: [
                            "<a class='fab fa-facebook fa-2x' href='https://www.facebook.com/westchestergear/' target='blank' aria-label='Link opens in new window (facebook.com/WestChesterGear)' ></a>",
                            "<a class='mobile-social' href='https://www.twitter.com/westchestergear' target='blank' aria-label='Link opens in new window (twitter.com/westchestergear)'><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><path d=\"M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z\"/></svg></a>",
                            "<a class='fab fa-instagram-square fa-2x' href='https://www.instagram.com/westchestergear/' target='blank' aria-label='Link opens in new window (instagram.com/westchestergear)'></a>",
                            "<a class='fab fa-youtube-square fa-2x' href='https://www.youtube.com/westchestergloves' target='blank' aria-label='Link opens in new window (youtube.com/westchestergloves)'></a>",
                            "<a class='fab fa-linkedin fa-2x' href='https://www.linkedin.com/company/west-chester-holdings' target='blank' aria-label='Link opens in new window (linkedin.com/company/west-chester-holdings)'></a>"
                        ]
                    }
                ]
            });
            const api = menu.API;

            $(".r-link").click(function() {
                api.close();
            });
        });
    },

};
</script>

<style lang="scss" scoped>
.category-heading{
    background: #000;
    display:block;
    padding:1rem 0.4rem;

}
nav #mobile-nav{
    display:none;
}
.modal.fade .modal-dialog {
    position: fixed;
    margin: auto;
    width: 500px;
    height: 100%;
    left: -500px;
    transition: opacity 0.4s linear, left 0.4s ease-out;
}

.modal.fade.show .modal-dialog {
    left: 0;
}

.modal .modal-content {
    height: 100%;
    overflow-y: auto;
}

.modal .modal-body {
    padding: 15px 15px 80px;
}

/* ----- MODAL STYLE ----- */
.modal-content {
    border-radius: 0;
    border: none;
}

.modal-header {
    border-bottom-color: #eeeeee;
    background-color: #fafafa;
}

button {
    &:hover {
        background: transparent;
    }
}

.router-link-active {
    border-bottom: 1px solid #222;
}
</style>
